import { Section } from "anketa-core/group";
import { Translation } from "anketa-core/i18n";
import { setupFortiGateGroup } from "./forti";

const FortiGateSetupEn = await fetch(require("./tutorial/setup/en.md")).then(
  (res) => res.text()
);
const FortiGateSetupDe = await fetch(require("./tutorial/setup/de.md")).then(
  (res) => res.text()
);

// Fresh section per catalog build - see network/section.ts for the rationale.
export const fortiGateScanners = (): Section => {
  const fortiGateScanners = new Section("forti_scanner", [
    new Translation("en", "FortiGate Scanners"),
    new Translation("en", "FortiGate-Scanner"),
  ]);
  fortiGateScanners.help = [
    new Translation(
      "en",
      `Add FortiGates to get more detailed information about their API!`
    ),
    new Translation(
      "de",
      `Fügen Sie FortiGates hinzu, um detailliertere Informationen über deren API zu erhalten!`
    ),
  ];

  fortiGateScanners.description = [
    new Translation("en", FortiGateSetupEn),
    new Translation("de", FortiGateSetupDe),
  ];

  setupFortiGateGroup(fortiGateScanners, 0);
  return fortiGateScanners;
};
